import {useAppDispatch} from 'core/redux/hooks/useAppDispatch';
import {useCallback} from 'react';
import {showAuthDialog} from 'modules/auth/thunks';

export const useShowAuthDialog = () => {
    const dispatch = useAppDispatch();

    return useCallback(() => {
        dispatch(showAuthDialog);
    }, [dispatch]);
};
